import axios from "axios";

import {
  LOGIN_SUCCESS,
  REFRESH_TOKEN,
  USER_LOADED,
  LOGIN_FAIL,
  AUTH_ERROR,
  LOGOUT_SUCCESS,
  AUTH_SET_LOADING,
  // GET_SUCCESS,
  GET_ERRORS,
  SET_AUTH_LOADING,
  EXPIRED_TOKEN,
  POST_NEWPASS,
  PASS_FAIL,
  PASSWORD_FAIL, 
  POST_NEWPASSWORD
} from '../actions/types'

import {setLoading ,authTokenConfig} from './utilActions'
// axios.defaults.xsrfCookieName = 'csrftoken'
// axios.defaults.xsrfHeaderName = "X-CSRFTOKEN"

// LoginUser
export const loginUser = (formData) => async dispatch => {
  dispatch({ type: SET_AUTH_LOADING })
  const config = {
    headers: {
      'Accept': "application/json",
      "Content-Type": "application/json",
    },
    method: "post",
    url: `/api/token/`,
    data: formData,
  };

  try {
    const response = await axios(config);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: response.data
    });

    // dispatch(
    //   loadUser()
    // )

  } catch (err) {
    console.log('login fail ',err)
    const errors = {
      msg: err.response.data,
      status: err.response.status
    }
    dispatch({
      type: LOGIN_FAIL,
      payload: errors.msg
    });
  }
}

export const refreshUser = () => async (dispatch, getState) => {
  const refresh = getState().authReducer.refresh;

  if (!refresh) return 0;

  const config = {
    method: "post",
    url: `/api/token/refresh/`,
    data: { refresh },
  };

  try {
    const response = await axios(config);
    dispatch({
      type: REFRESH_TOKEN,
      payload: response.data,
    });
  } catch (err) {
    console.log("error: ", JSON.stringify(err));
    dispatch({
      type: EXPIRED_TOKEN,
    });
  }
};



// LOAD USER
// export const loadUser = () => async (dispatch, getState) => {
//   dispatch(setLoading())
//   try {
//     const response = await axios.get(`/auth/users/me/`, authTokenConfig(getState));

//     dispatch({
//       type: USER_LOADED,
//       payload: response.data
//     })
//   } catch (err) {
//     if (err.response) {
//       const errors = {
//         msg: err.response.data,
//         status: err.response.status
//       }
//       dispatch({
//         type: GET_ERRORS,
//         payload: errors
//       })

//       dispatch({
//         type: AUTH_ERROR
//       })
//     } else {
//       console.log('authErr:', err)
//     }
//   }
// }

// LOGOUT USER
export const logoutUser = () => async (dispatch, getState) => {
  setAuthLoading()

  // try {
  //   await axios.post('/auth/token/logout/', null, configTokenSwitcher(getState));

    dispatch({
      type: LOGOUT_SUCCESS,
    })
  // } catch (err) {
  //   if (err.response.data) {
  //     const errors = {
  //       msg: err.response.data,
  //       status: err.response.status
  //     }
  //     dispatch({
  //       type: GET_ERRORS,
  //       payload: errors
  //     })
  //   } else {
  //     console.log({ "authErr": err })
  //   }
  // }
}
export const setAuthLoading= () => async (dispatch, getState) => {
  dispatch({
      type: SET_AUTH_LOADING
  })
}
//reset hasła - backup
export const changePassOld = (formData) => async dispatch => {
  dispatch({ type: SET_AUTH_LOADING })
  const config = {
    headers: {
      'Accept': "application/json",
      "Content-Type": "application/json",
    },
    method: "post",
    url: `/api/users/reset_password_old/`,
    data: formData,
  };

  try {
    const response = await axios(config);

    dispatch({
      type: POST_NEWPASS,
      payload: response.data
    });

    // dispatch(
    //   loadUser()
    // )

  } catch (err) {
    dispatch({
      type: PASS_FAIL,
      payload: err
    });
  }
}
//reset hasła
export const changePass = (formData) => async dispatch => {
  console.log('password change proc...')
  dispatch({ type: SET_AUTH_LOADING })
  const config = {
    headers: {
      'Accept': "application/json",
      "Content-Type": "application/json",
    },
    method: "post",
    url: `/api/users/reset_password/`,
    data: formData,
  };

  try {
    const response = await axios(config);
    console.log('password change response:')
    console.log(response)

    dispatch({
      type: POST_NEWPASS,
      payload: response.data
    });

    // dispatch(
    //   loadUser()
    // )

  } catch (err) {
    dispatch({
      type: PASS_FAIL,
      payload: err
    });
  }
}
//zmiana hasła
export const changePasswordProfile = (formData) => async dispatch => {
  dispatch({ type: SET_AUTH_LOADING })
  const token =  localStorage.getItem("token");
  const config = {
    headers: {
      'Accept': "application/json",
      "Content-Type": "application/json",
      "Authorization":`JWT ${token}`
    },
    method: "post",
    url: `/api/users/change_password/`,
    data: formData,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: POST_NEWPASS,
      payload: response.data
    });
  } catch (err) {
    console.log(JSON.stringify( err.response.data))
    dispatch({
      type: PASS_FAIL,
      payload:err.response.data
    });
  }
}